import { TrackingService } from '@rocheglobal/component-library-dot-com/src/services/tracking';
import { HistoryService } from '@rocheglobal/component-library-dot-com/src/services/history';

const defaultTracking = {
  event: 'language_switch',
  component_name: 'roche-language-switch',
  additionalParameters: {},
};

export function trackClick(fromLocale: string, toLocale: string): void {
  TrackingService.push({
    ...defaultTracking,
    additionalParameters: {
      from_locale: fromLocale,
      current_location: HistoryService.getActiveUrl().pathname,
    },
    value: toLocale,
  });
}
